import template from './companies-create.html';
import controller from './companies-create.controller';

const companiesCreateComponent = {
  template,
  controller,
  controllerAs: 'companiesCreate',
  require: {
    app: '^^app'
  }
};

export default companiesCreateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-create/companies-create.component.js
 **/